angular.module('IndicatorType').controller('IndicatorModalController', ['$scope', '$uibModalInstance', '$filter', 'data', function($scope, $uibModalInstance, $filter, data) {
  'use strict';

  $scope.indicator = data.indicator;
  $scope.existingKeys = data.keys;
  $scope.editKey = undefined;
  if(data.indicator.edit) {
    $scope.editKey = data.indicator.key;
    $scope.backup = angular.copy($scope.indicator);
  }

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    // if editing-mode - reset the indicator-values on cancel
    if($scope.indicator.edit) {
      $scope.indicator.title = $scope.backup.title;
      $scope.indicator.key = $scope.backup.key;
      $scope.indicator.default = $scope.backup.default;
      $scope.indicator.unit = $scope.backup.unit;
    }
    $uibModalInstance.dismiss($scope.indicator);
  };

  /**
   * Closes the modal window and returns the data for the new indicator
   * @param {object} indicator object consisting of title and category id
   */
  $scope.updateIndicator = function (indicator) {
    indicator.added = true;
    $uibModalInstance.close(indicator);
  };

  $scope.validateIndicatorKey = function (key) {

  };
}]);
